import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { Table } from 'antd'
import { Link } from 'react-router'
import { SmartImage } from '../../../../components/SmartImage'
import { Routes } from '../../../../constants/Routes'
import { INestedProduct } from '@getgreenline/homi-shared'
import { BlazeAlert } from '../../../../components/BlazeAlert/BlazeAlert'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  parentProduct: INestedProduct
}

@inject('currentCompanyStore')
@observer
export class ParentWarning extends React.Component<Props> {
  company = this.props.currentCompanyStore!.company!

  constructor(props: Props) {
    super(props)
  }

  render() {
    const { parentProduct } = this.props

    return (
      <BlazeAlert type='error' showIcon>
        <div style={{ overflowY: 'auto' }}>
          <div>{`This is a variant of an ${
            parentProduct.isActive ? 'active' : 'inactive'
          } parent product`}</div>

          <Table
            style={{ background: '#FFFFFF' }}
            className='mt-2'
            scroll={{ x: 'max-content' }}
            pagination={false}
            rowClassName={() => {
              return 'cursor-pointer'
            }}
            onRow={() => ({
              onClick: () => {
                const path = Routes.EDIT_PRODUCT(
                  this.company.id,
                  parentProduct.id,
                  window.location.search,
                )
                window.open(path, '_blank')
              },
            })}
            columns={[
              { title: 'Image', dataIndex: 'imageUrl', key: 'imageUrl', width: 52 },
              { title: 'Name', dataIndex: 'name', key: 'name', width: 240 },
              { title: 'SKU', dataIndex: 'sku', key: 'sku', width: 130 },
              {
                title: 'Category',
                dataIndex: 'parentCategoryName',
                key: 'parentCategoryName',
                width: 140,
              },
            ]}
            dataSource={[
              {
                key: '1',
                imageUrl: <SmartImage src={parentProduct.imageUrl} width={50} height={50} />,
                name: (
                  <Link
                    to={Routes.EDIT_PRODUCT(
                      this.company.id,
                      parentProduct.id,
                      window.location.search,
                    )}
                    target='_blank'
                  >
                    {parentProduct.name}
                  </Link>
                ),
                sku: parentProduct.sku,
                parentCategoryName: parentProduct.parentCategoryName,
              },
            ]}
          />
        </div>
      </BlazeAlert>
    )
  }
}
